// extracted by mini-css-extract-plugin
export default {"settings-container":"Settings_settings-container__yc-rY","dialog":"Settings_dialog__AWhzd"};